import { format } from 'date-fns';

import {
  _id,
  _ratings,
  _nativeS,
  _nativeM,
  _nativeL,
  _percents,
  _booleans,
  _sentences,
  _fullNames,
  _postTitles,
  _fullAddress,
  _descriptions,
  _phoneNumbers,
} from './assets';

// ----------------------------------------------------------------------

export const _mock = {
  id: (index) => _id[index],
  time: (year, month, day) => {
    const specificDate = new Date(year, month - 1, day);
    return format(specificDate, 'dd MMMM yyyy');
  },
  boolean: (index) => _booleans[index],
  postTitle: (index) => _postTitles[index],
  heading: (index) => _sentences[index],
  sentence: (index) => _sentences[index],
  description: (index) => _descriptions[index],
  // Contact
  phoneNumber: (index) => _phoneNumbers[index],
  fullAddress: (index) => _fullAddress[index],
  // Name
  fullName: (index) => _fullNames[index],
  // Number
  number: {
    percent: (index) => _percents[index],
    rating: (index) => _ratings[index],
    nativeS: (index) => _nativeS[index],
    nativeM: (index) => _nativeM[index],
    nativeL: (index) => _nativeL[index],
  },
};
